import { Dispatch, FC, SetStateAction } from 'react';
import { Divider, Stack } from '@mui/material';
import { TabContainerNew } from '../../../styles/TradeDocStyles';
import FilterTradeDocuments from '../tradeFilter/FilterTradeDocuments';
import { useUserProfile } from '../../../customhooks/useUserProfile';
import { hasPermission } from '../dashboardpage/utils';
import { SuitUIButton } from '../../SuitUIButton';
import { PlusIcon } from '../../icons/PlusIcon';

interface IProps {
    setShowAddModal: Dispatch<SetStateAction<boolean>>;
    setFilterOptions: any;
    filterOptions: any;
    fetchDocuments: any;
}

const DocumentPageHeader: FC<IProps> = ({
    setFilterOptions,
    filterOptions,
    setShowAddModal,
    fetchDocuments
}: IProps): JSX.Element => {
    const { permissions } = useUserProfile();

    return (
        <>
            <div className='mt-[24px] lg:mt-0 flex items-center px-4 lg:px-0 justify-between'>
                <h1 className='mb-4 text-xl text-black lg:text-[28px] lg:font-medium lg:text-appcolorblacktwo'>
                    Documents
                </h1>

                <div className='hidden lg:block'>
                    <TabContainerNew>
                        <Stack direction='row' spacing={'10px'}>
                            <FilterTradeDocuments
                                {...{
                                    setFilterOptions,
                                    filterOptions,
                                    fetchDocuments
                                }}
                            />
                            {permissions &&
                                hasPermission({
                                    userPermissions: permissions,
                                    module: 'tradeDocuments',
                                    permissionList: ['*', 'write']
                                }) && (
                                    <>
                                        {' '}
                                        <Divider
                                            orientation='vertical'
                                            flexItem
                                        />
                                        <div
                                            className='tab-buttons actif'
                                            onClick={() => {
                                                setShowAddModal(true);
                                            }}
                                        >
                                            <img
                                                src='/img/vectors/brokenplusBlack.svg'
                                                alt='plaindownload'
                                                className='h-[1.1rem]'
                                            />
                                            <p style={{ paddingLeft: '5px' }}>
                                                Create Document
                                            </p>
                                        </div>
                                    </>
                                )}
                        </Stack>
                    </TabContainerNew>
                </div>
            </div>

            <div className='px-4 lg:hidden'>
                <SuitUIButton
                    text='Create document'
                    onClick={() => {
                        setShowAddModal(true);
                    }}
                    fullWidth
                    invert
                    iconLeft={<PlusIcon color='#0088B2' />}
                    style='px-[0.92rem] border border-gray300 text-steelBlue font-medium text-sm leading-[20px]'
                />
            </div>
        </>
    );
};

export default DocumentPageHeader;
